import {FC} from "react";
import {styled} from "@mui/material/styles";

type AudioPlayerProps = {
    src?: string
}

const Audio = styled('audio')({
    width: "100%"
})

const AudioPlayer: FC<AudioPlayerProps> = (props) => {
    return <Audio controls {...props} />
}

export default AudioPlayer
